// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SG-z","twoColumnImage":"TG-z"};